export default "__VITE_ASSET__1b0b9755__"